import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    PurIndentDetailCreateRequestDTO,
    PurIndentDetailUpdateRequestDTO,
    PurIndentDetailDeleteRequestDTO,
    PurIndentDetailReadByIdRequestDTO,
    PurIndentDetailReadByIndentIdRequestDTO,
    PurIndentDetailDTO,
    PurIndentDetailList,
    PurIndentDetailReadByIndentAndVendorRequestRequestDTO,
    PurIndentDetailByIndentAndVendorList,
    PurIndentDetailReadByItemIdRequestDTO,
    PurIndentDetailReadByVendorIdRequestDTO,
    PurIndentDetailReadByIndentIdForImportRequestDTO,
    PurIndentDetailCreateBulkRequestDTO,
    IndentDetailUpsertBulkRequestDTO
} from './indent-detail.interface';

import {
    IndentDetail_Create,
    IndentDetail_Update,
    IndentDetail_Delete,
    IndentDetail_ReadAll,
    IndentDetail_ReadById,
    IndentDetail_ReadByIndentId,
    IndentDetail_ReadByIndentAndVendor,
    IndentDetail_ReadByIndentIdForImport,
    IndentDetail_ReadByItemId,
    IndentDetail_ReadByVendorId,
    IndentDetail_CreateBulk,
    IndentDetail_UpsertBulk,
} from 'src/app/GlobalVariables';

@Injectable({
    providedIn: 'root'
})
export class IndentDetailService {

    constructor() { }

    http = inject(HttpClient);

    IndentDetail_Create(data: PurIndentDetailCreateRequestDTO): Observable<PurIndentDetailDTO> {
        return this.http.post<PurIndentDetailDTO>(IndentDetail_Create, data);
    }

    IndentDetail_Update(data: PurIndentDetailUpdateRequestDTO): Observable<PurIndentDetailDTO> {
        return this.http.post<PurIndentDetailDTO>(IndentDetail_Update, data);
    }

    IndentDetail_Delete(data: PurIndentDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(IndentDetail_Delete, data);
    }

    IndentDetail_ReadAll(): Observable<PurIndentDetailList> {
        return this.http.get<PurIndentDetailList>(IndentDetail_ReadAll);
    }

    IndentDetail_ReadById(data: PurIndentDetailReadByIdRequestDTO): Observable<PurIndentDetailDTO> {
        return this.http.post<PurIndentDetailDTO>(IndentDetail_ReadById, data);
    }

    IndentDetail_ReadByItemId(data: PurIndentDetailReadByItemIdRequestDTO): Observable<PurIndentDetailList> {
        return this.http.post<PurIndentDetailList>(IndentDetail_ReadByItemId, data);
    }

     IndentDetail_ReadByVendorId(data: PurIndentDetailReadByVendorIdRequestDTO): Observable<PurIndentDetailList> {
        return this.http.post<PurIndentDetailList>(IndentDetail_ReadByVendorId, data);
    }


    IndentDetail_ReadByIndentId(data: PurIndentDetailReadByIndentIdRequestDTO): Observable<PurIndentDetailList> {
        return this.http.post<PurIndentDetailList>(IndentDetail_ReadByIndentId, data);
    }
    IndentDetail_ReadByIndentIdForImport(data: PurIndentDetailReadByIndentIdForImportRequestDTO): Observable<PurIndentDetailList> {
        return this.http.post<PurIndentDetailList>(IndentDetail_ReadByIndentIdForImport, data);
    }

    IndentDetail_ReadByIndentAndVendor(data: PurIndentDetailReadByIndentAndVendorRequestRequestDTO): Observable<PurIndentDetailByIndentAndVendorList> {
        return this.http.post<PurIndentDetailByIndentAndVendorList>(IndentDetail_ReadByIndentAndVendor, data);
    }

    IndentDetail_CreateBulk(data: PurIndentDetailCreateBulkRequestDTO): Observable<void> {
        return this.http.post<void>(IndentDetail_CreateBulk, data);
    }

    IndentDetail_UpsertBulk(data: IndentDetailUpsertBulkRequestDTO): Observable<PurIndentDetailList> {
        return this.http.post<PurIndentDetailList>(IndentDetail_UpsertBulk, data);
    }

}
